// Clases del <select> nativo — espejo del <Input> shadcn. Extraído de los forms (UserForm,
// RoleAssignmentDialog, etc.) para reusarlo en los <select> de filtro/paginación de las tablas
// sin duplicar la cadena de Tailwind en cada archivo.
export const SELECT_CLASS =
    'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50';
